import actionTypePrefixes from "../../actions/actionTypePrefixes"

const initialState = {
  isLoading: true,
  loadingFailed: false,
  reportSubmitInProgress: false,
  reportTypes: [],
  reviews: [],
  appraisalLevels: [],
  employeeDetailOptions: [],
  reviewData: null,
  employeeSearchResults: null,
  submittedReports: [],
  reportLoadingInProgress: false,
  autoRefreshing: false,
}

export default function customReportReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.CustomReport) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.CustomReport, "")

  switch (actionType) {
    case "LOAD_DASHBOARD_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: true,
        loadingFailed: false,
      }

    case "LOAD_DASHBOARD_DATA_SUCCESS":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        reportTypes: action.payload.data.reportTypes,
        appraisalLevels: action.payload.data.appraisalLevels,
        reviews: action.payload.data.reviews,
        employeeDetailOptions: action.payload.data.employeeDetailOptions,
        reviewData: null,
        employeeSearchResults: null,
        requestedReports: action.payload.data.requestedReports,
      }

    case "LOAD_DASHBOARD_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
        isLoading: false,
        loadingFailed: true,
        reportTypes: {
          ...state.reportTypes,
        },
      }
    case "LOAD_REVIEW_DATA":
      return {
        ...state,
      }

    case "LOAD_REVIEW_DATA_SUCCESS":
      return {
        ...state,
        reviewData: action.payload.data,
      }

    case "LOAD_REVIEW_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
      }

    case "REFRESH_SUBMITTED_REPORT_DATA":
      return {
        ...state,
        reportLoadingInProgress: true,
        autoRefreshing: action.isAutoRefresh,
      }

    case "REFRESH_SUBMITTED_REPORT_DATA_SUCCESS":
      return {
        ...state,
        reportLoadingInProgress: false,
        autoRefreshing: false,
        requestedReports: action.payload.data,
      }

    case "REFRESH_SUBMITTED_REPORT_DATA_FAIL":
      return {
        ...state,
        reportLoadingInProgress: false,
        autoRefreshing: false,
      }

    case "RESET_REPORT_SELECTION":
      return {
        ...state,
        reviewData: null,
      }
    case "EMPLOYEE_SEARCH":
      return {
        ...state,
      }

    case "EMPLOYEE_SEARCH_SUCCESS":
      return {
        ...state,
        employeeSearchResults: action.payload.data,
      }

    case "EMPLOYEE_SEARCH_RESET":
      return {
        ...state,
        employeeSearchResults: null,
      }
    case "EMPLOYEE_SEARCH_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
      }

    case "SUBMIT_CUSTOM_REPORT":
      return {
        ...state,
        reportSubmitInProgress: true,
      }
    case "SUBMIT_CUSTOM_REPORT_SUCCESS":
      return {
        ...state,
        reportSubmitInProgress: false,
      }

    case "SUBMIT_CUSTOM_REPORT_FAIL":
      return {
        ...state,
        reportSubmitInProgress: false,
      }

    case "DUMMY_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        reportTypes: [
          ...state.reportTypes,
          ...[
            { label: "Review Export", value: 1 },
            { label: "Goal Export", value: 2 },
            { label: "Coffee Chat Export", value: 3 },
          ],
        ],
        reviews: [
          ...state.reviews,
          ...[
            { label: "Annual Review 2018", value: 1580 },
            { label: "Mid Year Review 2017", value: 1570 },
            { label: "Annual Review 2017", value: 1560 },
          ],
        ],
        appraisalLevels: [
          ...state.appraisalLevels,
          ...[
            { label: "All", value: -1 },
            { label: "Core", value: 1 },
            { label: "Management", value: 2 },
            { label: "Senior Team", value: 3 },
          ],
        ],
      }

    case "DUMMY_REVIEW_DATA":
      return {
        ...state,
        isLoading: false,
        reviewData: {
          workflowSteps: [
            {
              clientWorkflowStepId: 1,
              nameTranslationIdentifier: "Emp",
              pages: [
                {
                  formPageId: 11,
                  nameTranslationIdentifier: "EP:Behaviours",
                  questions: [
                    {
                      questionId: 111,
                      textTranslationIdentifier: "EP:Individual Behaviour Score",
                    },
                    {
                      questionId: 112,
                      textTranslationIdentifier: "EP:Individual Behaviour Score",
                    },
                  ],
                },
                {
                  formPageId: 12,
                  nameTranslationIdentifier: "EP:Goals",
                  questions: [
                    {
                      questionId: 121,
                      textTranslationIdentifier: "EP:Individual Goal Score",
                    },
                    {
                      questionId: 122,
                      textTranslationIdentifier: "EP:Overall Goal Score",
                    },
                  ],
                },
              ],
            },
            {
              clientWorkflowStepId: 2,
              nameTranslationIdentifier: "Mgr",
              pages: [
                {
                  formPageId: 21,
                  nameTranslationIdentifier: "MP:Behaviours",
                  questions: [
                    {
                      questionId: 211,
                      textTranslationIdentifier: "MP:Individual Behaviour Score",
                    },
                    {
                      questionId: 212,
                      textTranslationIdentifier: "MP:Individual Behaviour Score",
                    },
                  ],
                },
                {
                  formPageId: 22,
                  nameTranslationIdentifier: "MP:Goals",
                  questions: [
                    {
                      questionId: 221,
                      textTranslationIdentifier: "MP:Individual Goal Score",
                    },
                    {
                      questionId: 222,
                      textTranslationIdentifier: "MP:Overall Goal Score",
                    },
                  ],
                },
              ],
            },
          ],
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/customReportReducer.js